import { ExtendedShareholderDTO } from "@/types/Shareholder";
import { Actor, ActorType } from "@/types/SelectActors";
import { toShareholderReference } from "@/utils/UrnReference";

export function mapToActors(shareholders: ExtendedShareholderDTO[]): Actor[] {
  return shareholders.map((shareholder) => ({
    type: ActorType.SHAREHOLDER,
    name: shareholder.name,
    isCompany: shareholder.isCompany,
    birthDateOrOrganisationNumber: shareholder.birthDateOrOrganisationNumber,
    availableActors: [
      {
        reference: toShareholderReference(shareholder.id),
        organisationNumber: shareholder.organizationNumber,
        companyName: "",
      },
    ],
    inCompany: { shareholderId: shareholder.id, companyRoleIds: [] },
  }));
}
